<template>
    <main>
      <PageHeaderUI
      title="Booking Confirmed"
      breadcrumb="Dashboard > Operations > Shipments"
    />
    <div class="h-8 w-full bg-white"></div>
     <div class="p-3">
      <div class="h-10 w-full flex justify-end">
        <button
        @click="closePage()"
        class="h-6 w-6 rounded-full border-red-500 text-red-500 border-2 flex justify-center items-center">&#x2715;</button>
      </div>
      <BookingDirection v-if="doorToDoorShow"/>
     </div>
    </main>
  </template>
  
  <script>
  import BookingDirection from "@/components/3pl/Operations/Bookings/NewBooking/BookingDirection.vue";
  import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
  
  export default {
    components: {
        BookingDirection,
        PageHeaderUI
    },
    data() {
      return {
        doorToDoorShow: true
      }
    },
    methods: {
      closePage(){
        this.doorToDoorShow = !this.doorToDoorShow
        this.$router.push('/operations/booking')
        this.$store.dispatch("resetState");
      }
    },
  };
  </script>
  
  <style></style>
  